import { Flex } from 'foundations-components/components/Flex';
import { RightAlignedTD } from '../styled/RightAlignedTD';
import { jsx as _jsx } from "react/jsx-runtime";
const CoverageRatioCell = ({
  coverage
}) => {
  return /*#__PURE__*/_jsx(RightAlignedTD, {
    children: /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      "data-test-id": "coverage-ratio",
      justifyContent: "end",
      children: coverage || coverage === 0 ? `${coverage.toFixed(1)}x` : '—'
    })
  });
};
export default CoverageRatioCell;